import { AxiosResponse } from 'axios';
import { isEmpty } from 'lodash-es';
import { useEffect, useState } from 'react';
import { IComposableDashboardContext } from 'wisestep-api';

import { useComposableDashboardsContext } from '../../../features/analyticsPage/hooks/useComposableDashboardsContext';

const url = 'api/composable-analytics';

const useBulkApi = (
  keyForBulkApi: string,
  generatedQuery: any,
  endpoint: string,
  customEndpoint?: boolean
) => {
  const { fetchChartsInBulk, pushChartPayloadForBulkFetch, getChartResponseFromBulk } =
    useComposableDashboardsContext() as Required<IComposableDashboardContext>;
  const [response, setResponse] = useState<AxiosResponse<any, any>>();
  useEffect(() => {
    if (fetchChartsInBulk)
      pushChartPayloadForBulkFetch(
        keyForBulkApi,
        generatedQuery,
        customEndpoint ? endpoint : `${url}${endpoint}`
      );
  }, [
    customEndpoint,
    endpoint,
    fetchChartsInBulk,
    generatedQuery,
    keyForBulkApi,
    pushChartPayloadForBulkFetch,
  ]);

  useEffect(() => {
    const data = getChartResponseFromBulk(keyForBulkApi);
    const fetchResponseFromBulk = () => {
      const response = {} as AxiosResponse<any, any>;
      response.data = data;
      setResponse(response);
    };
    if (fetchChartsInBulk.current && !isEmpty(data)) fetchResponseFromBulk();
  }, [fetchChartsInBulk, getChartResponseFromBulk, keyForBulkApi]);

  return { response };
};

export default useBulkApi;
